import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

import { AuthService } from '../../../services/auth/auth.service';

@Component({
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  visibleSpinner = true;

  // Variables para mensaje
  code: any;
  titulo: any;
  detalle: any;
  sw: any;

  constructor(private authService: AuthService, private router: Router) {
  }


  ngOnInit(): void {
    this.cerrarSesion();
  }

  cerrarSesion(): void {
    this.authService.cerrarSesion()
      .subscribe((res: any) => {
        if (res.success) {
          if (res.status_code === 200) {
            this.visibleSpinner = false;
            this.code = 'logout.success.default';
            setTimeout(() => {
              this.router.navigate(['auth/login']);
            }, 1000);
          }
        } else if (res.data.code === 42 || res.data.code > 43) {
          this.visibleSpinner = false;
          this.code = 'refresh.warn.default';
          setTimeout(() => {
            this.router.navigate(['auth/login']);
          }, 2000);
        }
      }, error => {
        this.visibleSpinner = false;
        this.code = 'logout.error.default';
      });
  }
}
